import {Component} from 'preact'
import {connect} from 'preact-redux';
import _ from 'lodash'

import Question from './Question/Question'

import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';

import PersistentRouting from '/chat/src/lib/LocalStorage/PersistentRouting'

import style from './style.scss'

class CategoryQuestions extends Component {
    constructor(props) {
        super(props);
        this._onQuestionClick = this._onQuestionClick.bind(this);

        this.state = {
            yTranslation: 5,
            opacity: 0
        }
    }

    componentDidMount() {
        setTimeout(() => this.setState({ yTranslation: 0, opacity: 1 }), 15)
    }

    _onQuestionClick(id) {
        this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskArticle', this.props.activeCategory, id));
    }

    render() {
        const { yTranslation, opacity } = this.state
        const { questions } = this.props
        return (
            <div style={{transform: `translateY(${yTranslation}px)`, opacity: opacity}}
                className={`${style.QuestionsContainer} ${style.CustomScroll}`}>
                    { questions.toJS().map((q,i) => {
                        return <Question onClick={() => this._onQuestionClick(q['id'])}
                            key={i}
                            questionTitle={q['question']} /> })
                    }
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const activeCategoryId = FeaturesModel.getCategoryId(state, ownProps.activeCategory)
    let questions = FeaturesModel.getActiveQuestions(state);
    questions = questions.filter(question => question.get('category_id') === activeCategoryId)
    return { questions }
}

export default connect(mapStateToProps)(CategoryQuestions);



// WEBPACK FOOTER //
// ./routes/HelpDesk/CategoryQuestions/CategoryQuestions.js